import React, { useState } from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { TbCaretUpDownFilled } from "react-icons/tb";
import { useSport } from "../../../../context/SportContext.tsx";
import { Schedule } from "../../../../models/Schedule.tsx";

type TeaserTableProps = {
    game: Schedule;
    showLeagueBanner?: boolean;
    showColumnHeaders?: boolean;
};

export function TableComponents({
    game,
    showLeagueBanner = true,
    showColumnHeaders = true,
}: TeaserTableProps) {
    const { refreshSelectedGames } = useSport();
    const [isRotating, setIsRotating] = useState(false);

    const handleRefresh = () => {
        setIsRotating(true);
        refreshSelectedGames();
    };

    return (
        <div className={`schedule-table${!showLeagueBanner ? ' schedule-table--columns-only' : ''}${!showColumnHeaders ? ' schedule-table--banner-only' : ''}`}>
            {showLeagueBanner && (
                <div className="d-flex justify-content-between align-items-center container-table-bets">
                    <div className="d-flex justify-content-between align-items-center">
                        {/* <img src={game.leagueLogo} className="league-logo" alt="" /> */}
                        <span className="nameTeam teko">{game.league.name}</span>
                    </div>
                </div>
            )}
            {showColumnHeaders && (
                <div className="d-flex align-items-center color-title">
                    <div className="team-name-container">
                        <button className="refresh-button d-lg-none" onClick={handleRefresh}>
                            <HiOutlineRefresh className={`refresh-icon ${isRotating ? "rotate" : ""}`} />
                            <span className="refresh">REFRESH</span>
                        </button>
                    </div>
                    <div className="spread-container center-container">
                        <span className="title-table-game d-none d-lg-block">SPREAD</span>
                        <span className="title-table-game d-lg-none">STREAD / ML</span>
                        <span className="spread-icons"><TbCaretUpDownFilled className="iconSM" /></span>
                    </div>
                    <div className="moneyline-container center-container d-none d-lg-block">
                        <span className="title-table-game d-none d-lg-block">MONEYLINE</span>
                        <span className="title-table-game d-lg-none d-lg-block">STREAD / ML</span>
                        <span className="spread-icons"><TbCaretUpDownFilled className="iconSM" /></span>
                    </div>
                    <div className="total-container center-container">
                        <span className="title-table-game d-none d-lg-block">TOTAL</span>
                        <span className="title-table-game d-lg-none">TOTAL/TT</span>
                        <span className="spread-icons"><TbCaretUpDownFilled className="iconSM" /></span>
                    </div>
                    <div className="over-under-container center-container d-none d-lg-block">
                        <span className="title-table-game d-none d-lg-block">TEAM TOTAL</span>
                        <span className="title-table-game d-lg-none d-lg-block">TOTAL/TT</span>
                        <span className="spread-icons"><TbCaretUpDownFilled className="iconSM" /></span>
                    </div>
                </div>
            )}
        </div>
    );
}
